import React from 'react';
import './style.scss';
import logo from '../../../../../assets/images/logo.svg';
import submitIcon from '../../../../../assets/images/submittedIcon.svg';
import { withTranslation } from 'react-i18next';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

const TravelStepThree = ({ t }) => {
  return (
    <div className="DocumentStepThreecontainer">
      {/* header */}
      
      <div className="titleContainer">
        <span className="title">{t('titleTripDateForm')}</span>
        <span className="subTitle">{t('subTitleTripDateForm')}</span>
      </div>
      {/* sub Header */}
      <div className="subHeader">
        <div className="firstSpan">
          <span>{t('firstSpanTripDateForm')}</span>
        </div>
      </div>
      {/* card  */}
      <div className="submitCard">
        <img src={submitIcon} alt="submit icon" className="submitIcon" />
        {/* card text */}
        <div className="cardText">
          <div className="cardTitle">
            <span>{t('CardTitle')}</span>
          </div>
          <div className="cardSubTitle">
            <span>
              {t('cardSubTitle')}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(withSitecoreContext()(TravelStepThree));
